import axios from "axios";
import $config from "@appConfig";

const DADATA_API_CURRENT_USER_KLADR = 'https://suggestions.dadata.ru/suggestions/api/4_1/rs/detectAddressByIp';
const DADATA_API_URL = 'https://suggestions.dadata.ru/suggestions/api/4_1/rs/suggest/party';

/**
 * Сервис для определения юридического лица, компании...
 * @link https://dadata.ru/suggestions/#party
 */
export class DaData
{
    /**
     * Текущий КЛАДР клиента для приоритета выдачи подсказок.
     * Сохраняем в переменную для исключения повторного запроса данных.
     * @type {String|null}
     */
    static kladrId = null;

    /**
     * Получение подсказок DaData
     * @param {String} word
     * @param {Function|null} alertError callback функция для вывода ошибки
     *
     * Выведены только интересующие нас поля, их на много больше...
     * @returns {Promise<{
     *     value: String,
     *     data: {
     *         inn: String,
     *         kpp: String,
     *         address: {
     *             unrestricted_value: String,
     *         },
     *     }
     * }[]|[]>}
     */
    static async getSuggestions(word, alertError = null)
    {
        const kladrId = await this.getClientKladr();

        try {
            let payload = {
                query: word,
                status: ["ACTIVE"], // только активные
            }

            /**
             * На всякий случай, если не удалось по какой-то причине получить данные по КЛАДР.
             * Параметр не обязателен, нужен только при приоритета выдачи по локации.
             */
            if (kladrId) {
                payload.locations_boost = [{
                    kladr_id: kladrId
                }];
            }

            const response = await axios({
                method: 'post',
                url: DADATA_API_URL,
                data: payload,
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    "Authorization": `Token ${$config.DADATA_API_KEY}`
                },
            });

            return response.data.suggestions;
        } catch (error) {
            if (alertError) {
                alertError(error);
            }

            return [];
        }
    }

    /**
     * Назначаем текущий КЛАДР клиента для приоритета выдачи подсказок
     * @returns {Promise<void>}
     */
    static async setClientKladr()
    {
        await axios({
            method: 'get',
            url: DADATA_API_CURRENT_USER_KLADR,
            headers: {
                "Authorization": `Token ${$config.DADATA_API_KEY}`,
                "Accept": "application/json"
            }
        })
        .then(response => {
            this.kladrId = response?.data?.location?.data?.kladr_id;
        });
    }

    /**
     * Получаем текущий КЛАДР клиента
     * @returns {Promise<String|null>}
     */
    static async getClientKladr()
    {
        if (this.kladrId === null) {
            await this.setClientKladr();
        }

        return this.kladrId;
    }
}
